module.exports = __webpack_public_path__ + "img/art2-img4.c2e78615.jpeg";